// Library Imports
import React from 'react'
import * as FaIcons from 'react-icons/fa'
import * as CgIcons from 'react-icons/cg'
import * as MdIcons from 'react-icons/md'
// Asset Imports

function HorizontalEntryCard({ entry }) {

    const imageSrc = `data:image/jpeg;base64,${entry.Picture}`;

    return (
        <div className='horizontalentrycard'>
            <div className='horizontalentrycard-media'>
                <img height={400} width={450} src={imageSrc} />
            </div>
            <div className='horizontalentrycard-content'>
                <div className='horizontalentrycard-content-title'>
                    {entry.OrganizationName || entry.LastName}
                </div>
                <div className='horizontalentrycard-content-description'>
                    {entry.OwnerName || entry.FirstName}
                </div>
                  <div className='horizontalentrycard-content-description'>
                    {entry.Prefix ? (`Prefix: ${entry.Prefix}`) : (<></>)}
                    {entry.CowCount ? (`Cow Count: ${entry.CowCount}`) : (<></>)}
                </div>
                <div>
                    <div>
                        <MdIcons.MdLocationOn className='horizontalentrycard-content-contact-icon' />
                        {
                            entry.Address2 ? (
                                `${entry.Address1}, ${entry.Address2}, ${entry.City}, ${entry.StateProvince}, ${entry.ZipCode}`) : (
                                `${entry.Address1}, ${entry.City}, ${entry.StateProvince}, ${entry.ZipCode}`)
                        }

                    <div>
                        {
                            entry.LocationDescription ? (
                                <div>
                                    <div className='horizontalentrycard-farmmessage-title'>Farm Location</div>
                                    {entry.LocationDescription}
                                </div>) : (
                                <></>
                            )
                        }
                    </div>

                        {
                            entry.HomePhone ? (
                                <div>
                                    <MdIcons.MdPhone className='horizontalentrycard-content-contact-icon' />
                                    {entry.HomePhone}
                                </div>) : (
                                <></>
                            )
                        }
                        {
                            entry.WorkPhone ? (
                                <div>
                                    <MdIcons.MdWork className='horizontalentrycard-content-contact-icon' />
                                    {entry.WorkPhone}
                                </div>) : (
                                <></>
                            )
                        }
                        {
                            entry.CellPhone ? (
                                <div>
                                    <FaIcons.FaMobileAlt className='horizontalentrycard-content-contact-icon' />
                                    {entry.CellPhone}
                                </div>) : (
                                <></>
                            )
                        }

                    {
                        entry.Email ? (
                            <div>
                                <MdIcons.MdMail className='horizontalentrycard-content-contact-icon' />
                                <a href={`mailto:${entry.Email}`}>{entry.Email}</a>
                            </div>
                        ) : (
                            <></>
                        )
                    }
                        {
                            entry.Fax ? (
                                <div>
                                    <FaIcons.FaFax className='horizontalentrycard-content-contact-icon' />
                                    {entry.Fax}
                                </div>) : (
                                <></>
                            )
                        }

                    </div>
                    <div>
                        {
                            entry.FarmMessage ? (
                                <div>
                                    <div className='horizontalentrycard-farmmessage-title'>Listing Message</div>
                                    {entry.FarmMessage}
                                </div>) : (
                                <></>
                            )
                        }
                    </div>
                </div>
                <div className='horizontalentrycard-seperator'></div>
                <div className='horizontalentrycard-quick-actions'>

                    {
                        entry.WebsiteURL ? (
                            <a href={entry.WebsiteURL} target='blank' rel='noopener'>
                                <CgIcons.CgWebsite />
                            </a>) : (
                            <></>
                        )
                    }

                    {
                        entry.FacebookURL ? (
                            <a href={entry.FacebookURL} target='blank' rel='noopener'>
                                <FaIcons.FaFacebookF />
                            </a>) : (
                            <></>
                        )
                    }

                    {
                        entry.LinkedInURL ? (
                            <a href={entry.LinkedInURL} target='blank' rel='noopener'>
                                <FaIcons.FaLinkedinIn />
                            </a>) : (
                            <></>
                        )
                    }

                    {
                        entry.YoutubeURL ? (
                            <a href={entry.YoutubeURL} target='blank' rel='noopener'>
                                <FaIcons.FaYoutube />
                            </a>) : (
                            <></>
                        )
                    }

                    {
                        entry.InstagramURL ? (
                            <a href={entry.InstagramURL} target='blank' rel='noopener'>
                                <FaIcons.FaInstagram />
                            </a>) : (
                            <></>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default HorizontalEntryCard